export default "__VITE_ASSET__BnQheyrK__"